import { render, staticRenderFns } from "./SectionSustainability.vue?vue&type=template&id=6d9a460c&"
import script from "./SectionSustainability.vue?vue&type=script&lang=js&"
export * from "./SectionSustainability.vue?vue&type=script&lang=js&"
import style0 from "./SectionSustainability.vue?vue&type=style&index=0&id=6d9a460c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports